import React from 'react';
import { Container, Row } from 'react-bootstrap';
import estiloInicio from './Inicio.module.css';

import Banner from '../components/Banner';
import CardHero from '../components/CardHero';
import AcercaDe from '../components/AcercaDe';
import WhatsappFloatButton from '../components/WhatsappFloatButton';
import GoogleMapComponent from '../components/GoogleMapComponent';

import LogoSrc from '../assets/card/diente.png';
import LogoSrc2 from '../assets/card/silla.png';
import LogoSrc3 from '../assets/card/docto.png';
import serv1 from '../assets/card/especialistas.webp';
import serv2 from '../assets/card/servicios.webp';
import serv3 from '../assets/card/contacto.webp';


function Inicio() {


    return (
        <>
            <div className={estiloInicio.fondo}>
                <div className={estiloInicio.InicioBanner}>
                    <Banner />
                </div>

                <AcercaDe />
                <Container>

                    <div className={`${estiloInicio["about-content"]} text-start`} data-aos="zoom-in">
                        <h1>Tu sonrisa está en buenas manos</h1>
                        <p>En Dentisan queremos verte sonreír. Por eso, te ofrecemos atención cálida, tratamientos modernos y un equipo que se preocupa por ti. Aquí podrás conocer a nuestros especialistas, los servicios que ofrecemos y cómo agendar tu cita fácilmente.</p>

                    </div>



                    <Row>
                        <CardHero
                            imageSrc={serv1}
                            logoSrc={LogoSrc2}
                            mainText="Especialistas"
                            date=""
                            buttonText="Leer más"
                            buttonLink="../Nosotros"
                            backTitle="Especialistas"
                            backText="Contamos con un equipo de especialistas altamente calificados en todas las áreas de la odontología para brindarte la mejor atención."
                        />
                        <CardHero
                            imageSrc={serv2}
                            logoSrc={LogoSrc}
                            mainText="Servicios"
                            date=""
                            buttonText="Leer más"
                            buttonLink="../Servicios"
                            backTitle="Servicios"
                            backText="Ofrecemos una amplia gama de servicios dentales con tecnología avanzada y un enfoque personalizado para cuidar tu sonrisa."
                        />
                        <CardHero
                            imageSrc={serv3}
                            logoSrc={LogoSrc3}
                            mainText="Contáctenos"
                            date=""
                            buttonText="Leer más"
                            buttonLink="../Contacto"
                            backTitle="Contáctenos"
                            backText="Ponte en contacto con nosotros para agendar tu cita o resolver cualquier duda sobre nuestros servicios."
                        />
                    </Row>

                </Container>
                <WhatsappFloatButton />
                <GoogleMapComponent />
            </div>
        </>
    );
}

export default Inicio;
